module.exports = __webpack_public_path__ + "static/media/badge5.10910516.svg";